import { usePlaylist } from '../../savedItems';
import { usePlaylistIdFromSearch } from '../hooks';
import ContentViewport from '../../../components/ContentViewport';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import H3 from 'UIComponents/elements/headings/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUserInfo } from '../../accounts';
import formatFriendlyName from 'I18n/utils/formatFriendlyName';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LearningContentContainer } from '../../learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'exam-finished-screen';
const StyledUIIllustration = styled(UIIllustration).withConfig({
  displayName: "PlaylistComplete__StyledUIIllustration",
  componentId: "bghvdc-0"
})(["margin-right:50px;margin-left:50px;", ""], mediaQuery('tablet', css(["display:none;"])));
export const PlaylistComplete = () => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);
  const {
    userInfo
  } = useUserInfo();
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    children: [/*#__PURE__*/_jsx(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "center",
        children: [/*#__PURE__*/_jsx(StyledUIIllustration, {
          name: "success"
        }), playlist && userInfo && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlistContent.completePlaylistContent.completeTitle",
              options: {
                name: formatFriendlyName({
                  givenName: userInfo.user.firstName,
                  familyName: userInfo.user.lastName
                })
              }
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlistContent.completePlaylistContent.completeSubtitle"
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        to: "/",
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistContent.completePlaylistContent.completeCta"
        })
      })
    })]
  });
};